import { createSelector } from '@reduxjs/toolkit';

const propertiesReducer = (state) => state.propertiesReducer;

export const propertiesStateSelector = createSelector([propertiesReducer], (propertiesState) => propertiesState);

export const propertiesSelector = createSelector([propertiesReducer], ({ properties }) => ({
    properties
}));

export const propertyByIdSelector = (id) =>
    createSelector([propertiesSelector], ({ properties }) => ({
        property: properties.find((property) => property.id === id)
    }));
